import Typewriter from 'typewriter-effect/dist/core';

function startWriting(element) {
    
    let tw = new Typewriter(element, {
        delay: 0
    });
    return tw;
}
  
export { startWriting };